<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card title="Fusion de deux débiteurs" class="bg-light shadow">
          <b-row>
            <b-col lg="6">
              <mh-select
                class="mt-1"
                :table="table"
                field="sourceID"
                :autocomplete="{
                  field:
                    'debiteur.(nom_soc ID) || debiteur.(nom prenom ID) || debiteur.ID',
                }"
                @change="getSourceDebtor()"
              ></mh-select>
              <b-card class="mt-3" v-if="source_debtor_loaded">
                <h6>
                  {{ source_debtor.nom_soc.value }}
                  <span v-if="source_debtor.nom.value"
                    >({{
                      (
                        source_debtor.prenom.value +
                        " " +
                        source_debtor.nom.value
                      ).trim()
                    }}) </span
                  >(#{{ source_debtor.ID.value }})
                  <b-button
                    @click="migrate()"
                    v-if="source_debtor_loaded && target_debtor_loaded"
                    variant="success"
                    size="sm"
                    class="float-right"
                    >Transférer
                    <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill
                  ></b-button>
                </h6>

                <div v-if="source_debtor.warrants.length > 0">
                  <table
                    class="
                          table
                          b-table
                          table-striped table-hover
                          b-table-fixed
                          table-sm
                          mt-3
                        "
                  >
                    <tr v-for="(item, i) in source_debtor.warrants" :key="i">
                      <td>{{ toDate(item.date_ouverture) }}</td>
                      <td>
                        <strong
                          ><b-link
                            :to="{
                              name: 'warrantView',
                              params: { id: item.ID },
                            }"
                            >{{ item.ID }}</b-link
                          ></strong
                        >
                      </td>
                      <td>{{ item.status_i18n }}</td>
                      <td>
                        <strong
                          ><b-link
                            :to="{
                              name: 'creditorView',
                              params: { id: item.creancierID },
                            }"
                            >{{ item.creancier }}</b-link
                          ></strong
                        >
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-else>
                  <b-alert show>Pas de mandat pour ce débiteur</b-alert>
                </div>
              </b-card>
            </b-col>
            <b-col lg="6">
              <mh-select
                class="mt-1 mr-2"
                :table="table"
                field="targetID"
                :autocomplete="{
                  field:
                    'debiteur.(nom_soc ID) || debiteur.(nom prenom ID) || debiteur.ID',
                }"
                @change="getTargetDebtor()"
              ></mh-select>
              <b-card class="mt-3" v-if="target_debtor_loaded">
                <h6>
                  {{ target_debtor.nom_soc.value }}
                  <span v-if="target_debtor.nom.value"
                    >({{
                      (
                        target_debtor.prenom.value +
                        " " +
                        target_debtor.nom.value
                      ).trim()
                    }})
                  </span>
                  (#{{ target_debtor.ID.value }})
                </h6>
                <div v-if="target_debtor.warrants.length > 0">
                  <table
                    class="
                          table
                          b-table
                          table-striped table-hover
                          b-table-fixed
                          table-sm
                          mt-3
                        "
                  >
                    <tr v-for="(item, i) in target_debtor.warrants" :key="i">
                      <td>{{ toDate(item.date_ouverture) }}</td>
                      <td>
                        <strong
                          ><b-link
                            :to="{
                              name: 'warrantView',
                              params: { id: item.ID },
                            }"
                            >{{ item.ID }}</b-link
                          ></strong
                        >
                      </td>
                      <td>{{ item.status_i18n }}</td>
                      <td>
                        <strong
                          ><b-link
                            :to="{
                              name: 'creditorView',
                              params: { id: item.creancierID },
                            }"
                            >{{ item.creancier }}</b-link
                          ></strong
                        >
                      </td>
                    </tr>
                  </table>
                </div>
                <div v-else>
                  <b-alert show>Pas de mandat pour ce débiteur</b-alert>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import MhSelect from "@/components/MhSelect.vue";
import debtors from "@/services/debtors";
export default {
  name: "fusionDebtors",
  components: {
    MhSelect,
  },
  data() {
    return {
      busy: false,
      table: {
        sourceID: {
          label: "Débiteur source",
          value: "",
          type: "int",
        },
        targetID: {
          label: "Débiteur destination",
          value: "",
          type: "int",
        },
      },
      source_debtor: null,
      target_debtor: null,
      source_debtor_loaded: false,
      target_debtor_loaded: false,
      warrantsFields: [
        {
          key: "date_ouverture",
          label: "Date",
          sortable: true,
        },
        {
          key: "ID",
          label: "Numéro de mandat",
          sortable: true,
        },
        {
          key: "status_i18n",
          label: "Statut",
          sortable: true,
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
        },
      ],
      items: [
        {
          text: "Administration",
          to: { name: "administration" },
        },
        {
          text: "Fusion de deux débiteurs",
        },
      ],
    };
  },
  methods: {
    async getSourceDebtor(id = null) {
      this.busy = true;
      this.source_debtor_loaded = false;
      if (id !== null) {
        this.table.sourceID.value = id;
      }
      if (this.table.sourceID.value == 0) return;
      await debtors.get(this.table.sourceID.value).then((response) => {
        this.source_debtor = response.data;
      });
      await debtors
        .warrants_info(this.table.sourceID.value)
        .then((response) => {
          this.source_debtor.warrants = response.data;
        });
      this.source_debtor_loaded = true;
      this.busy = false;
    },
    async getTargetDebtor(id = null) {
      this.busy = true;
      this.target_debtor_loaded = false;
      if (id !== null) {
        this.table.targetID.value = id;
      }
      if (this.table.targetID.value == 0) return;
      await debtors.get(this.table.targetID.value).then((response) => {
        this.target_debtor = response.data;
      });
      await debtors
        .warrants_info(this.table.targetID.value)
        .then((response) => {
          this.target_debtor.warrants = response.data;
        });
      this.target_debtor_loaded = true;
      this.busy = false;
    },

    toDate(d) {
      return DateTime.humanDate(d);
    },
    async migrate() {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir migrer ces mandats?", {
          cancelTitle: "Annuler",
          okTitle: "Migrer",
        })
        .then(() => {
          this.busy = true;

          debtors
            .warrants_migrate(
              this.table.sourceID.value,
              this.table.targetID.value
            )
            .then(() => {
              this.getSourceDebtor();
              this.getTargetDebtor();
            });
          this.busy = false;
        })
        .catch(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
